import { IRaisePropertyChanged } from "./IRaisePropertyChanged";

export class NotifyMap<K, V> extends Map<K, V> {
    private readonly propertyName: string;

    public get name(): string {
        return this.propertyName;
    }

    private readonly ownerValue: IRaisePropertyChanged;

    public constructor(owner: IRaisePropertyChanged, name: string, entries?: readonly (readonly [K, V])[] | null) {
        super(entries);
        this.ownerValue = owner;
        this.propertyName = name;
    }
    
    public override clear(): void {
        super.clear();
        this.ownerValue.raisePropertyChanged(this.propertyName);
    }

    public override delete(key: K): boolean {
        const value = super.delete(key);
        this.ownerValue.raisePropertyChanged(this.propertyName);
        return value;
    }

    public override set(key: K, value: V): this {
        super.set(key, value);
        this.ownerValue.raisePropertyChanged(this.propertyName);
        return this;
    }
}